import React from 'react';
import PropTypes from 'prop-types';
import { getPossibleSplitAttrs } from '../../../config/dataAttributesIndex';
import { convertType } from '../../../config/constants';

const SplitAttributeSelect = (props) => {
  const { currentSplitAttr, category, onChangeAttr } = props;

  const handleChangeSplitAttr = (e) => {
    onChangeAttr(category, e.target.value);
  };

  return (
    <div className="field is-horizontal">
      <div className="field-label">
        <label
          className="label has-text-grey is-small"
          htmlFor="sortSplitAttr"
          style={{ whiteSpace: 'nowrap' }}
        >
          Sort By:
        </label>
      </div>
      <div className="field-body">
        <div className="field is-narrow">
          <div className="control">
            <div className="select is-rounded is-small">
              <select
                name="sortSplitAttr"
                onChange={handleChangeSplitAttr}
                value={currentSplitAttr}
              >
                {getPossibleSplitAttrs(convertType(category)).map(([splitAttr, name]) => (
                  <option value={splitAttr} key={splitAttr}>
                    {name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

SplitAttributeSelect.propTypes = {
  currentSplitAttr: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  onChangeAttr: PropTypes.func.isRequired,
};

export default SplitAttributeSelect;



// WEBPACK FOOTER //
// ./src/components/pages/collections/SplitAttributeSelect.jsx